export const resolveMailConfigSelection = (configs) => {
    if(configs.length===0){
        return {emailConfig:false,initialConfig:null}
    }
    if(configs.length===1){
        return {emailConfig:configs,initialConfig:configs[0]}
    }
    return {
        emailConfig:configs,
        initialConfig:configs.find(config=>config.is_default===true) || null,
    }
}
